import __request__ from "routing/request";
export function createFromParser(rule, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule", rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function metricsConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/config/metrics", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateMetricsConfig(JSONbody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/config/metrics", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function functionDescriptors(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/functions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBulk(rules, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/multiple", rules, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function parse(rule, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/parse", rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rulebuilderConditions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/rulebuilder/conditions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rulebuilderFunctions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/rulebuilder/functions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function simulate(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/simulate", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(rule, id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/${id}`, rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rule/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
